import { create } from "zustand";
import { persist } from "zustand/middleware";
import { tariffsResponseDto } from "../../api/interfaces/tariffsResponseDto";
import { createTariffResponseDto } from "../../api/interfaces/createTariffResponseDto";

interface tariffsState {
  tariffs: tariffsResponseDto | null;
  linkCurrentTariff: string | null;
  setTariffs: (tariffs: tariffsResponseDto | null) => void;
  setLinkCurrentTariff: (link: createTariffResponseDto | null) => void;
  clearTariffs: () => void;
}

export const tariffsStore = create<tariffsState>()(
  persist(
    (set) => ({
      tariffs: null,
      linkCurrentTariff: null,
      setTariffs: (tariffs) => {
        set({
          linkCurrentTariff: null,
          tariffs: tariffs,
        });
      },

      clearTariffs: () =>
        set({
          linkCurrentTariff: null,
          tariffs: null,
        }),
      setLinkCurrentTariff: (link) =>
        set({
          linkCurrentTariff: link?.confirmation_url,
        }),
    }),
    {
      name: "tariffs-storage",
    }
  )
);
